import React from 'react';
import './App.css';
import Ai4Jokes from './pages/AI4Jokes';
import AssetContextProvider from './context/AssetContext';
import Preloader from './pages/Preloader';
import { AssetList } from './loaders/AssetList';

function App(): JSX.Element
{
  return (
    <div className='App'>
      <AssetContextProvider>
        <Preloader assets={AssetList}>
          <Ai4Jokes></Ai4Jokes>
        </Preloader>
      </AssetContextProvider>
    </div>
  );
}

export default App;
